/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GuardianCreateWithLinkDto { 
    firstName: string;
    lastName: string;
    idNumber: string;
    email?: string;
    phone: string;
    /**
     * ID of the learner to link on creation
     */
    learnerId: number;
    type: GuardianCreateWithLinkDto.TypeEnum;
}
export namespace GuardianCreateWithLinkDto {
    export const TypeEnum = {
        Father: 'FATHER',
        Mother: 'MOTHER',
        Guardian: 'GUARDIAN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


